<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Search Users You Follow
      </p>
      <button class="delete" @click="$emit('close')"></button>
    </header>
    <section class="modal-card-body">

      <p v-if="!$store.getters.isLoggedIn">
        Log in to see people you follow.
      </p>
      <p v-else-if="friends === null">
        Loading people you follow...
      </p>
      <p v-else-if="friends.length === 0">
        You currently don't follow anyone!
      </p>
      <div v-else>
        <b-field label="Drag a name to @mention them in your tweet. Click to view their timeline.">
          <b-input placeholder="Filter..."
                   type="search"
                   icon-pack="fas"
                   v-model="search"
                   icon="search"
                   @dragenter.native.prevent="$event.dataTransfer.dropEffect='none'"
                   @dragover.native.prevent="$event.dataTransfer.dropEffect='none'"
                   @drop.native.prevent="$event.dataTransfer.dropEffect='none'"

          >
          </b-input>
        </b-field>
        <b-field>
          <div class="friends-list" id="friends-list">
            <div class="level"
                 v-for="friend in filteredFriends"
                 :key="friend.id">
                <div class="level-left"
                     @dragstart="startDrag($event, friend)"
                     draggable="true">
                  <div class="level-item">
                    <figure class="image mx-0 mr-2" v-observe-visibility="{ callback: (isVisible, entry) => friendVisibilityChange(isVisible, entry, friend), throttle: 50 }">
                      <img class="is-rounded" :src="friendImages[friend.id] || '/images/default-profile-mini.png'" :alt="`Profile pic of ${friend.screen_name}`"/>
                    </figure>
                  </div>
                  <div class="level-item">
                    <router-link
                        :to="`/app/timelines/@${friend.screen_name}`">
                      {{ friend.name }} (@{{ friend.screen_name }})
                    </router-link>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <b-icon v-if="friend.verified" icon="certificate" type="is-info" alt="Verified" title="Verified"></b-icon>
                  </div>
                  <div class="level-item">
                    <followers-tag :followers="friend.followers_count" />
                  </div>
                </div>
            </div>
          </div>
        </b-field>
      </div>

    </section>

  </div>

</template>

<script>

import FollowersTag from "../controls/FollowersTag";
export default {
  name: "FindUsersModal",
  components: {FollowersTag},
  data() {
    return {
      search: '',
      friendImages: {}
    }
  },
  computed: {
    friends() {
      return this.$store.state.auth.friends
    },
    authProfile() {
      return this.$store.state.auth.profile
    },
    searchKeywords() {
      return this.search.trim().toLowerCase().split(' ')
    },
    filteredFriends() {
      let searchRelationship = (user, keyword) =>
          user.screen_name.toLowerCase().includes(keyword) ||
          user.name.toLowerCase().includes(keyword);

      if (this.searchKeywords && this.friends) {
        return this.friends.filter(f => {
          return this.searchKeywords.every(keyword => searchRelationship(f, keyword))
        })
      } else {
        return this.friends
      }
    }
  },

  methods: {
    friendVisibilityChange(isVisible, entry, friend) {
      if (isVisible && !this.friendImages[friend.id]) {
        // add it to our object - make sure interactive
        this.$set(this.friendImages, friend.id, friend.image_url_mini)
      }
    },
    startDrag(event, friend) {
      event.dataTransfer.setData('text/plain', '@' + friend.screen_name + ' ')
      this.$emit('close')
    }
  }

}
</script>

<style scoped>
.friends-list {
  height: 20rem;
  overflow-y: scroll;
}
.friends-list .level {
  padding: 0.5rem;
  margin-bottom: 0;
}
.friends-list .level:hover {
  background-color: #f5f5f5;
}
.friends-list .level:not(:last-child) {
  border-bottom: 1px solid #ededed;
}
</style>
